import { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import useLocalLicense from "../hooks/useLocalLicense";

interface ILicenseValidChecker {
  fallbackContent?: ReactNode;
}

const LicenseValidChecker: FunctionComponent<
  PropsWithChildren<ILicenseValidChecker>
> = ({ children, fallbackContent }) => {
  const { isLocalLicenseValidOrOnline, isLocalLicenseLoading } =
    useLocalLicense();

  const fallbackContentWhenNotLoading = isLocalLicenseLoading
    ? null
    : fallbackContent;

  return (
    <>
      {isLocalLicenseValidOrOnline ? children : fallbackContentWhenNotLoading}
    </>
  );
};

export default LicenseValidChecker;
